import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

/* SEO */
import SeoMeta from "../components/SEO/SeoMeta";

/* Layout */
import Header from "../components/LandingPage/Header";
import FooterLinks from "../components/LandingPage/FooterLinks";

/* Sections */
import MarketNetworkHero from "../components/LandingPage/MarketNetworkHero";
import HubsSection from "../components/LandingPage/HubsSection";
import M2TStatsBar from "../components/LandingPage/M2TStatsBar";
import FeaturedBrokers from "../components/LandingPage/FeaturedBrokers";
import SmartCardLoop from "../components/smartcard/SmartCardLoop";
import FaqPreviewSection from "../components/LandingPage/FaqPreviewSection";
import Reviews from "../components/LandingPage/Reviews";
import M2THeroBanner from "../components/LandingPage/M2THeroBanner";

/* AI / Extras */
import PlatformTourVideos from "components/LandingPage/PlatformTourVideos";
import TrilliAIActionSection from "components/LandingPage/TrilliAIActionSection";
import StayConnectedMarkets from "components/LandingPage/StayConnectedMarkets";
import SellYourExpertise from "components/LandingPage/SellYourExpertise";
import TrendingMarketTools from "components/LandingPage/TrendingMarketTools";
import TopTraders from "components/LandingPage/TopTraders";
import ExpertInterviews from "components/LandingPage/ExpertInterviews";
import UpcomingEvents from "components/LandingPage/UpcomingEvents";
import MarketTickerStrip from "components/LandingPage/MarketTickerStrip";
import PlatformTourSlider from "components/LandingPage/PlatformTourSlider";
import RecognitionSection from "../components/LandingPage/RecognitionSection";
import WhoWeConnectSection from "../components/LandingPage/WhoWeConnectSection";

const HEADER_HEIGHT = 64; // must match actual header height

export default function LandingPage() {
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setPageReady(true));
  }, []);

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-[#0B0F19] text-white">
      {/* ---------- GLOBAL STYLE ---------- */}
      <style>{`
        html, body {
          background-color: #000;
          overflow-x: hidden;
        }

        .landing-wrapper {
          opacity: 0;
          transition: opacity 0.6s ease;
        }

        .landing-visible {
          opacity: 1;
        }
      `}</style>

      {/* ---------- SEO ---------- */}
      <SeoMeta
        title="Million2Trillion (M2T) — Verified Global Market Network"
        description="The intelligent, scam-free professional market network & marketplace."
        url="https://million2trillion.com/"
      />
      <Helmet>
        <title>Million2Trillion — Verified Market Network</title>
      </Helmet>

      {/* ---------- FIXED HEADER ---------- */}
      <div className="fixed left-0 top-0 z-50 w-full">
        <Header />
      </div>

      {/* ---------- HEADER SPACER ---------- */}
      <div style={{ height: HEADER_HEIGHT }} />

      {/* ---------- PAGE CONTENT ---------- */}
      <div className={`landing-wrapper ${pageReady ? "landing-visible" : ""}`}>
        {/* HERO + STATS */}
        <div className="flex min-h-[100dvh] w-full flex-col">
          <MarketNetworkHero />
          <MarketTickerStrip />
          <WhoWeConnectSection />
          <RecognitionSection />
        </div>

        {/* SECTIONS */}
        <PlatformTourSlider />
        <HubsSection />
        <TrilliAIActionSection />

        <StayConnectedMarkets />
        <SellYourExpertise />
        <TrendingMarketTools />
        <FeaturedBrokers />
        <TopTraders />
        <ExpertInterviews />
        <UpcomingEvents />
        <SmartCardLoop />
        <FaqPreviewSection />
        <Reviews />

        <FooterLinks />
      </div>
    </div>
  );
}
